var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.12566 9.5625L8.25066 10.6875L10.8757 8.0625M6.61677 3.79504L5.0699 3.54966C4.58117 3.47213 4.13687 3.84494 4.12835 4.33971L4.1014 5.90569C4.09656 6.18651 3.94732 6.44501 3.70653 6.58961L2.36384 7.39594C1.93961 7.65071 1.8389 8.22189 2.1504 8.60638L3.13634 9.82331C3.31315 10.0415 3.36498 10.3355 3.27348 10.601L2.76321 12.0818C2.602 12.5496 2.89199 13.0519 3.37777 13.1462L4.91527 13.4447C5.19099 13.4982 5.41965 13.6901 5.52024 13.9523L6.08116 15.4147C6.25839 15.8767 6.8034 16.075 7.23615 15.835L8.6058 15.0754C8.85142 14.9392 9.14991 14.9392 9.39553 15.0754L10.7652 15.835C11.1979 16.075 11.7429 15.8767 11.9202 15.4147L12.4811 13.9523C12.5817 13.6901 12.8103 13.4982 13.0861 13.4447L14.6236 13.1462C15.1093 13.0519 15.3993 12.5496 15.2381 12.0818L14.7278 10.601C14.6363 10.3355 14.6882 10.0415 14.865 9.82331L15.8509 8.60638C16.1624 8.22188 16.0617 7.65071 15.6375 7.39594L14.2948 6.58961C14.054 6.44501 13.9048 6.18651 13.8999 5.90569L13.873 4.33971C13.8645 3.84494 13.4202 3.47213 12.9314 3.54966L11.3846 3.79504C11.1072 3.83904 10.8267 3.73695 10.6425 3.52494L9.61521 2.34266C9.29066 1.96911 8.71067 1.96911 8.38611 2.34266L7.35887 3.52494C7.17466 3.73695 6.89417 3.83904 6.61677 3.79504Z",
    stroke: "#FF7926",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.6cc1e743b4ce61a3ee3c1c3722ee3e9e.svg";
export { ForwardRef as ReactComponent };